
import Moment from 'moment';

// Dublin
const routeData1 = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-122.42, 37.78],
      },
      properties: {
        description: null,
        airportCode: 'OAK',
        date: new Moment('2018-05-22 07'),
        anchor: 'top',
        airline: 'British Airways',
        flightNumber: '321',
        price: '600.00',
        class: 'Economy',
        seatGuruRanking: 'A+',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-6.249738, 53.426454],
      },
      properties: {
        description: 'Dublin, Ireland',
        airportCode: 'DUB',
        date: new Moment('2018-05-22 15'),
        anchor: 'right',
        airline: 'British Airways',
        flightNumber: '321',
        price: '600.00',
        class: 'Economy',
        seatGuruRanking: 'A+',
      },
    },
  ],
};

// New York
const routeData2 = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-122.42, 37.78],
      },
      properties: {
        description: null,
        airportCode: 'OAK',
        date: new Moment('2018-05-22 07'),
        anchor: 'top',
        airline: 'British Airways',
        flightNumber: '321',
        price: '600.00',
        class: 'Economy',
        seatGuruRanking: 'A+',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-73.7827, 40.6444],
      },
      properties: {
        description: 'New York, USA',
        airportCode: 'JFK',
        date: new Moment('2018-05-22 15'),
        anchor: 'bottom',
        airline: 'British Airways',
        flightNumber: '321',
        price: '600.00',
        class: 'Economy',
        seatGuruRanking: 'A+',
      },
    },
  ],
};

// London
const routeData3 = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-122.42, 37.78],
      },
      properties: {
        description: null,
        airportCode: 'OAK',
        date: new Moment('2018-05-22 07'),
        anchor: 'top',
        airline: 'British Airways',
        flightNumber: '321',
        price: '600.00',
        class: 'Economy',
        seatGuruRanking: 'A+',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-0.454295, 51.470020],
      },
      properties: {
        description: 'London, United Kingdom',
        airportCode: 'LHR',
        date: new Moment('2018-05-22 15'),
        anchor: 'right',
        airline: 'British Airways',
        flightNumber: '321',
        price: '600.00',
        class: 'Economy',
        seatGuruRanking: 'A+',
      },
    },
  ],
};


// Rejkavik
const routeData4 = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-122.42, 37.78],
      },
      properties: {
        description: null,
        airportCode: 'OAK',
        date: new Moment('2018-05-22 07'),
        anchor: 'top',
        airline: 'British Airways',
        flightNumber: '321',
        price: '600.00',
        class: 'Economy',
        seatGuruRanking: 'A+',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-21.946295, 64.1319],
      },
      properties: {
        description: 'Reykjavík',
        airportCode: 'RKV',
        date: new Moment('2018-05-22 15'),
        anchor: 'top',
        airline: 'British Airways',
        flightNumber: '321',
        price: '600.00',
        class: 'Economy',
        seatGuruRanking: 'A+',
      },
    },
  ],
};

// Rio
const routeData5 = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-122.42, 37.78],
      },
      properties: {
        description: null,
        airportCode: 'OAK',
        date: new Moment('2018-05-22 07'),
        anchor: 'top',
        airline: 'British Airways',
        flightNumber: '321',
        price: '600.00',
        class: 'Economy',
        seatGuruRanking: 'A+',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-43.154620, -22.908967],
      },
      properties: {
        description: 'Rio de Janeiro, Brazil',
        airportCode: 'GIG',
        date: new Moment('2018-05-22 15'),
        anchor: 'right',
        airline: 'British Airways',
        flightNumber: '321',
        price: '600.00',
        class: 'Economy',
        seatGuruRanking: 'A+',
      },
    },
  ],
};

// Tokyo
const routeData6 = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-122.42, 37.78],
      },
      properties: {
        description: null,
        airportCode: 'OAK',
        date: new Moment('2018-05-22 07'),
        anchor: 'top',
        airline: 'British Airways',
        flightNumber: '321',
        price: '600.00',
        class: 'Economy',
        seatGuruRanking: 'A+',
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-219.780396, 35.549611],
      },
      properties: {
        description: 'Tokyo, Japan',
        airportCode: 'HND',
        date: new Moment('2018-05-22 15'),
        anchor: 'left',
        airline: 'British Airways',
        flightNumber: '321',
        price: '600.00',
        class: 'Economy',
        seatGuruRanking: 'A+',
      },
    },
  ],
};


const slideData = [routeData1, routeData2, routeData3, routeData4, routeData5, routeData6];

export default slideData;



// WEBPACK FOOTER //
// ./src/tripData1.js